// extracted by mini-css-extract-plugin
module.exports = {"box":"index-module--box--2FQlQ","title_en":"index-module--title_en--3_6XV","title_ja":"index-module--title_ja--3Dwqb","attention":"index-module--attention--38lzd"};